@if (canView()) {
  <section class="wn-card asset-charges-panel">
    <div class="wn-card__head">
      <strong>{{ 'ASSET_CHARGES.PANEL_TITLE' | translate }}</strong>
    </div>
    <div class="asset-charges-panel__table-wrap">
      <table class="asset-charges-panel__table">
        <thead>
          <tr>
            <th scope="col">{{ 'ASSET_CHARGES.EMPLOYEE' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.REASON_LABEL' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.TOTAL' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.REMAINING' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.STATUS_LABEL' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.id) {
            <tr class="asset-charges-panel__row">
              <td><a [routerLink]="['/assets/charges', row.id]">{{ row.userFullName || '-' }}</a></td>
              <td>{{ 'ASSET_CHARGES.REASON.' + row.reason | translate }}</td>
              <td dir="ltr">{{ row.amount }}</td>
              <td dir="ltr">{{ row.remaining }}</td>
              <td><wn-status-chip [label]="'ASSET_CHARGES.STATUS.' + row.status | translate" /></td>
            </tr>
          } @empty {
            <tr><td colspan="5">{{ 'ASSET_CHARGES.EMPTY' | translate }}</td></tr>
          }
        </tbody>
      </table>
    </div>
  </section>
}
